// Enterprise Landing Page - Premium AI & Custom Solutions
import React from 'react';
import { Navigation } from '@/components/navigation';
import { Footer } from '@/components/footer';
import { EnterpriseHero } from '@/components/enterprise/enterprise-hero';
import { EnterpriseCapabilities } from '@/components/enterprise/enterprise-capabilities';
import { EnterpriseCaseStudies } from '@/components/enterprise/enterprise-case-studies';
import { EnterpriseBenefits } from '@/components/enterprise/enterprise-benefits';
import { EnterpriseProcess } from '@/components/enterprise/enterprise-process';
import { EnterpriseCTA } from '@/components/enterprise/enterprise-cta';
import { SEO } from '@/components/seo';

const Enterprise = () => {
  return (
    <>
      <SEO 
        title="Enterprise AI & Custom Software | AffinityAim"
        description="AI-powered solutions for enterprise scale. From logistics optimization to intelligent CRMs, we build systems that transform operations and deliver measurable ROI."
        keywords="enterprise AI, custom software, logistics optimization, AI integration, scalable systems"
      />
      <div className="min-h-screen bg-[#0a0a0a]">
        <Navigation />
        <main>
          <EnterpriseHero />
          <EnterpriseCapabilities />
          <EnterpriseCaseStudies />
          <EnterpriseBenefits />
          <EnterpriseProcess />
          <EnterpriseCTA />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Enterprise;
